import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {  OilViscosityMakeCorrespondence } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import { IReferential } from '../../../interfaces/IReferential';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { Autocomplete } from '@material-ui/lab';
import * as R from 'ramda';

interface IOilViscosityMakeCorrespondenceComponentState {
  newOilViscosityMakeCorrespondence: OilViscosityMakeCorrespondence;
  oilViscosityMakeCorrespondences: OilViscosityMakeCorrespondence[];
  oilViscosityList: IReferential[];
  carMakeList: IReferential[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newOilViscosityMakeCorrespondenceId: number | null;
}
type IOilViscosityMakeCorrespondenceComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class OilViscosityMakeCorrespondenceComponent extends React.PureComponent<
  IOilViscosityMakeCorrespondenceComponentProps,
  IOilViscosityMakeCorrespondenceComponentState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newOilViscosityMakeCorrespondence = {
    id: 0
  } as OilViscosityMakeCorrespondence;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newOilViscosityMakeCorrespondence: this.newOilViscosityMakeCorrespondence,
    oilViscosityMakeCorrespondences: [],
    oilViscosityList: [] as IReferential[],
    carMakeList: [] as IReferential[],
    newOilViscosityMakeCorrespondenceId: null
  } as IOilViscosityMakeCorrespondenceComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadOilViscosityMakeCorrespondences();
      }
    );
  }

  loadOilViscosityMakeCorrespondences = async () => {
    const oilViscosityRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.OilViscosity
    );
    const makeRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CarBrands
    );
    const [oilViscosityMakeCorrespondences, oilViscosityList, carMakeList] = await Promise.all([
      this.organizationService.GetUserOilViscosityMakeCorrespondences(),
      this.appReferentialService.Get(oilViscosityRef!.baseUrl),
      this.appReferentialService.Get(makeRef!.baseUrl)
    ]);

    oilViscosityMakeCorrespondences.forEach(item => {
      const make = carMakeList.find(make => !R.isNil(item.makeId) && make.id === item.makeId);
      item.make = R.isNil(make) ? null : make;
    });

    this.setState({
      oilViscosityMakeCorrespondences: oilViscosityMakeCorrespondences,
      oilViscosityList: oilViscosityList,
      carMakeList: carMakeList,
      isLoading: false,
      newOilViscosityMakeCorrespondence: { ...this.newOilViscosityMakeCorrespondence } as OilViscosityMakeCorrespondence
    });
  };

  public saveOilViscosityMakeCorrespondence = async () => {
    if (this.state.newOilViscosityMakeCorrespondenceId === null) {
      if (
        this.state.oilViscosityMakeCorrespondences.findIndex(
          (item) => item.oilViscosityId === this.state.newOilViscosityMakeCorrespondence.oilViscosityId &&
                    item.makeId === this.state.newOilViscosityMakeCorrespondence.makeId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'OIL_VISCOSITY_MAKE_CORRESPONDENCE_ALREADY_EXIST',
            'Aceasta asociere deja exista'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.organizationService.AddOilViscosityMakeCorrespondence(this.state.newOilViscosityMakeCorrespondence);
        await this.loadOilViscosityMakeCorrespondences();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.organizationService.UpdateOilViscosityMakeCorrespondence(this.state.newOilViscosityMakeCorrespondence);
        await this.loadOilViscosityMakeCorrespondences();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  private handleMakeChange = (newValue: IReferential | null) => {
    this.setState({
      newOilViscosityMakeCorrespondence: {
        ...this.state.newOilViscosityMakeCorrespondence,
        make: newValue,
        makeId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleOilViscosityChange = (newValue: IReferential | null) => {
    this.setState({
      newOilViscosityMakeCorrespondence: {
        ...this.state.newOilViscosityMakeCorrespondence,
        oilViscosity: newValue,
        oilViscosityId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleCorrespondenceChange = (value: string) => {
    this.setState({
      newOilViscosityMakeCorrespondence: {
        ...this.state.newOilViscosityMakeCorrespondence,
        correspondence: value
      }
    });
  };
  
  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveOilViscosityMakeCorrespondence} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="brand"
            fullWidth
            options={this.state.carMakeList}
            value={this.state.newOilViscosityMakeCorrespondence.make}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleMakeChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="brand"
                value={this.state.newOilViscosityMakeCorrespondence.make}
                label={this.translatorService.Tranlate(
                  'OIL_VISCOSITY_MAKE_CORRESPONDENCE_CAR_MAKE_LABEL',
                  'Marca'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="oilViscosity"
            fullWidth
            options={this.state.oilViscosityList}
            value={this.state.newOilViscosityMakeCorrespondence.oilViscosity}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleOilViscosityChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="oilViscosity"
                value={this.state.newOilViscosityMakeCorrespondence.oilViscosity}
                label={this.translatorService.Tranlate(
                  'ORGANIZATIONS_TAB_OIL_VISCOSITY',
                  'Viscozitate Ulei'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="correspondence"
            id="correspondence"
            value={this.state.newOilViscosityMakeCorrespondence.correspondence || ''}
            onChange={(e: any) => this.handleCorrespondenceChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'OIL_VISCOSITY_MAKE_CORRESPONDENCE_CORRESPONDENCE_LABEL',
              'Corespondenta'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'make',
        label: this.translatorService.Tranlate('OIL_VISCOSITY_MAKE_CORRESPONDENCE_CAR_MAKE_LABEL', 'Marca'),
        options: {
          filter: true,
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'oilViscosity',
        label: this.translatorService.Tranlate(
          'ORGANIZATIONS_TAB_OIL_VISCOSITY',
          'Viscozitate Ulei'
        ),
        options: {
          filter: true,
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name : 'correspondence',
        label: this.translatorService.Tranlate(
          'OIL_VISCOSITY_MAKE_CORRESPONDENCE_CORRESPONDENCE_LABEL',
          'Corespondenta'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newOilViscosityMakeCorrespondencePopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteOilViscosityMakeCorrespondence(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deleteOilViscosityMakeCorrespondence = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.organizationService.RemoveOilViscosityMakeCorrespondence(id);
      await this.loadOilViscosityMakeCorrespondences();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newOilViscosityMakeCorrespondencePopup = async (oilViscosityMakeCorrespondenceId: number | null) => {
    let newOilViscosityMakeCorrespondence: OilViscosityMakeCorrespondence;
    if (oilViscosityMakeCorrespondenceId == null) {
      newOilViscosityMakeCorrespondence = { ...this.state.newOilViscosityMakeCorrespondence } as OilViscosityMakeCorrespondence;
    } else {
      newOilViscosityMakeCorrespondence = this.state.oilViscosityMakeCorrespondences.find((item) => item.id === oilViscosityMakeCorrespondenceId)!;
    }
    this.setState({
      isDialogOpen: true,
      newOilViscosityMakeCorrespondence: newOilViscosityMakeCorrespondence,
      newOilViscosityMakeCorrespondenceId: oilViscosityMakeCorrespondenceId
    });
  };

  closeDialog = async () => {
    this.setState(
      { 
        isDialogOpen: false, 
        newOilViscosityMakeCorrespondence: this.newOilViscosityMakeCorrespondence 
      }
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newOilViscosityMakeCorrespondencePopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.oilViscosityMakeCorrespondences}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newOilViscosityMakeCorrespondenceId ? 
                    this.translatorService.Tranlate(
                      'OIL_VISCOSITY_MAKE_CORRESPONDENCE_ADD_MODAL_TITLE',
                      'Adauga corespondență vâscozitate ulei'
                    ) : this.translatorService.Tranlate(
                      'OIL_VISCOSITY_MAKE_CORRESPONDENCE_UPDATE_MODAL_TITLE',
                      'Actualizeaza corespondență vâscozitate ulei'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) 
        : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(OilViscosityMakeCorrespondenceComponent as any));